<div class="skin-filter-viewer">
  <div class="photo-container">
    <div class="photo-wrapper">
      <img
        [src]="photoUrl"
        [alt]="'results.skinFilterViewer.analysisPhoto' | translate"
        class="base-photo"
      />
      @if (activeFilter && getActiveFilterData()) {
      <img
        [src]="getFilterMaskUrl(getActiveFilterData()!.output_mask_name)"
        [alt]="'results.skinFilterViewer.filterOverlay' | translate"
        class="filter-overlay"
      />
      }

      <!-- Sub-filter controls overlaid on top-right of photo -->
      @if (hasSubFilters()) {
      <div class="sub-filter-overlay">
        <div class="sub-filter-toggle" (click)="toggleSubFilters()">
          <span class="toggle-icon">{{ isSubFilterExpanded ? "−" : "+" }}</span>
        </div>
        @if (isSubFilterExpanded) {
        <div class="sub-filter-controls">
          @for (subFilter of subFilters; track subFilter.key) {
          <button
            class="sub-filter-button"
            [class.active]="activeSubFilter === subFilter.key"
            (click)="selectSubFilter(subFilter.key)"
          >
            {{ subFilter.name }}
          </button>
          }
        </div>
        }
      </div>
      }
    </div>
  </div>

  <div class="filter-section">
    <div class="filter-description">
      @if (getActiveFilterData()) {
      <h3>
        {{ getActiveFilterData()!.name }}
        {{ "results.skinFilterViewer.analysis" | translate }} -
        <strong>{{ getActiveFilterData()!.ui_score }}</strong>
      </h3>
      <p>
        {{ getFilterDescription(activeFilter) }}
      </p>
      }
    </div>

    <div class="filter-controls">
      <button
        class="scroll-arrow scroll-arrow-left"
        (click)="scrollLeft()"
        [disabled]="!canScrollLeft"
      >
        <span>‹</span>
      </button>
      <div
        class="filter-scroll-container"
        role="group"
        [class.dragging]="isDragging"
        #scrollContainer
        (mousedown)="onDragStart($event)"
        (mousemove)="onDragMove($event)"
        (mouseup)="onDragEnd()"
        (mouseleave)="onDragEnd()"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd()"
        (scroll)="onScroll()"
      >
        @for (filter of filters; track filter.key) {
        <div
          class="filter-circle"
          role="button"
          tabindex="0"
          [attr.aria-pressed]="activeFilter === filter.key"
          [attr.aria-label]="filter.name + ' ' + filter.ui_score"
          [class.active]="activeFilter === filter.key"
          (click)="selectFilter(filter.key)"
          (keydown.enter)="selectFilter(filter.key)"
          (keydown.space)="$event.preventDefault(); selectFilter(filter.key)"
        >
          <div class="filter-score-container">
            <div
              class="filter-score"
              [style.background-color]="
                activeFilter === filter.key
                  ? getFilterFillColor(filter.key)
                  : 'white'
              "
              [style.border-color]="getFilterColor(filter.key)"
              [style.color]="activeFilter === filter.key ? 'white' : '#333'"
            >
              {{ filter.ui_score }}
            </div>
            @if (filter.subFilters && filter.subFilters.length > 0) {
            <div
              class="plus-indicator"
              [style.background-color]="getFilterColor(filter.key)"
            >
              +
            </div>
            }
          </div>
          <span class="filter-name">{{ filter.name }}</span>
        </div>
        }
      </div>
      <button
        class="scroll-arrow scroll-arrow-right"
        (click)="scrollRight()"
        [disabled]="!canScrollRight"
      >
        <span>›</span>
      </button>
    </div>
  </div>
</div>
